import { Link, useLocation } from "react-router-dom";
import { styled, alpha } from "@mui/material/styles";
import InputBase from "@mui/material/InputBase";
import SearchIcon from "@mui/icons-material/Search";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import Toolbar from "@mui/material/Toolbar";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import Menu from "@mui/material/Menu";
import MenuIcon from "@mui/icons-material/Menu";
import Container from "@mui/material/Container";
import Button from "@mui/material/Button";
import Tooltip from "@mui/material/Tooltip";
import MenuItem from "@mui/material/MenuItem";
import "../menu/Menu.scss";
import Label from "../../elements/label/Label";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setSearch } from "../../store/searchSelector";
import { setTheme } from "../../store/themeSelector";
import api from "../../api";
import SendIcon from "@mui/icons-material/Send";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import { API_MEDIA } from "../../env";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import ChatIcon from "@mui/icons-material/Chat";
import FitnessCenterIcon from "@mui/icons-material/FitnessCenter";
import FolderZipIcon from "@mui/icons-material/FolderZip";
import PeopleIcon from "@mui/icons-material/People";
import PhotoCameraIcon from "@mui/icons-material/PhotoCamera";
import DockIcon from "@mui/icons-material/Dock";
import ContactsIcon from "@mui/icons-material/Contacts";
import ReportProblemIcon from "@mui/icons-material/ReportProblem";
import { useTheme } from "@mui/material/styles";
import { Switch } from "@mui/material";
import FormControlLabel from "@mui/material/FormControlLabel";

const MaterialUISwitch = styled(Switch)(({ theme }) => ({
  width: 62,
  height: 34,
  padding: 7,
  "& .MuiSwitch-switchBase": {
    margin: 1,
    padding: 0,
    transform: "translateX(6px)",
    "&.Mui-checked": {
      color: theme.color.main,
      transform: "translateX(22px)",
      "& .MuiSwitch-thumb:before": {
        backgroundImage: `url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" height="20" width="20" viewBox="0 0 20 20"><path fill="${encodeURIComponent(
          theme.color.main,
        )}" d="M4.2 2.5l-.7 1.8-1.8.7 1.8.7.7 1.8.6-1.8L6.7 5l-1.9-.7-.6-1.8zm15 8.3a6.7 6.7 0 11-6.6-6.6 5.8 5.8 0 006.6 6.6z"/></svg>')`,
      },
      "& + .MuiSwitch-track": {
        opacity: 1,
        backgroundColor: theme.color.third,
      },
    },
  },
  "& .MuiSwitch-thumb": {
    backgroundColor: theme.color.secondary,
    width: 32,
    height: 32,
    "&::before": {
      content: "''",
      position: "absolute",
      width: "100%",
      height: "100%",
      left: 0,
      top: 0,
      backgroundRepeat: "no-repeat",
      backgroundPosition: "center",
      backgroundImage: `url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" height="20" width="20" viewBox="0 0 20 20"><path fill="${encodeURIComponent(
        theme.color.main,
      )}" d="M9.305 1.667V3.75h1.389V1.667h-1.39zm-4.707 1.95l-.982.982L5.09 6.072l.982-.982-1.473-1.473zm10.802 0L13.927 5.09l.982.982 1.473-1.473-.982-.982zM10 5.139a4.872 4.872 0 00-4.862 4.86A4.872 4.872 0 0010 14.862 4.872 4.872 0 0014.86 10 4.872 4.872 0 0010 5.139zm0 1.389A3.462 3.462 0 0113.471 10a3.462 3.462 0 01-3.473 3.472A3.462 3.462 0 016.527 10 3.462 3.462 0 0110 6.528zM1.665 9.305v1.39h2.083v-1.39H1.666zm14.583 0v1.39h2.084v-1.39h-2.084zM5.09 13.928L3.616 15.4l.982.982 1.473-1.473-.982-.982zm9.82 0l-.982.982 1.473 1.473.982-.982-1.473-1.473zM9.305 16.25v2.083h1.389V16.25h-1.39z"/></svg>')`,
    },
  },
  "& .MuiSwitch-track": {
    opacity: 1,
    backgroundColor: theme.color.third,
    borderRadius: 20 / 2,
  },
}));

const Item = styled(Link)(({ theme }) => ({
  padding: theme.spacing(0),
  textAlign: "center",
  color: alpha(theme.color.secondary, 1),
  // backgroundColor: alpha(theme.color.main, 1),
  textDecoration: "none",
}));

const Bar = styled(AppBar)(({ theme }) => ({
  position: "fixed",
  backgroundColor: alpha(theme.color.main, 1),
  // color: alpha(theme.color.secondary, 1),
  // color: theme.palette.text.secondary,
}));

const Item_Button = styled(Button)(({ theme }) => ({
  padding: theme.spacing(0),
  color: alpha(theme.color.secondary, 1),
  padding: 5,
}));

const Search = styled("div")(({ theme }) => ({
  position: "relative",
  color: theme.palette.text.dark,
  borderRadius: theme.shape.borderRadius,
  backgroundColor: theme.color.input,
  "&:hover": {
    backgroundColor: theme.color.input_hover,
  },

  width: "100%",
  // [theme.breakpoints.up("sm")]: {
  //   marginLeft: theme.spacing(1),
  //   width: "200px",
  // },
  [theme.breakpoints.down("md")]: {
    width: "150px",
    marginLeft: 0,
  },
  [theme.breakpoints.up("md")]: {
    width: "250px",
  },
  [theme.breakpoints.up("lg")]: {
    width: "250px",
  },
  [theme.breakpoints.up("xl")]: {
    width: "250px",
  },
}));

const SearchIconWrapper = styled("div")(({ theme }) => ({
  padding: theme.spacing(0, 2),
  height: "100%",
  position: "absolute",
  pointerEvents: "none",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
}));

const StyledInputBase = styled(InputBase)(({ theme }) => ({
  color: "inherit",
  width: "100%",
  "& .MuiInputBase-input": {
    padding: theme.spacing(1, 1, 1, 0),
    // vertical padding + font size from searchIcon
    paddingLeft: `calc(1em + ${theme.spacing(4)})`,
    transition: theme.transitions.create("width"),
    [theme.breakpoints.up("sm")]: {
      width: "12ch",
      "&:focus": {
        width: "20ch",
      },
    },
  },
}));

function ResponsiveAppBar() {
  const theme = useTheme();

  // const [isToggled, setIsToggled] = useState(false);

  // const handleChange = (event) => {
  //   setIsToggled(event.target.checked);
  //   dispatch(setTheme());
  // };
  const flag = useSelector((state) => state.themeSelector.theme);

  const [anchorElNav, setAnchorElNav] = useState(null);
  const [anchorElDoc, setAnchorElDoc] = useState(null);
  const [anchorElSport, setAnchorElSport] = useState(null);
  const [searchValue, setSearchValue] = useState("");
  const dispatch = useDispatch();
  const [staff, setStaff] = useState(false);
  const pages = [
    <Item to={"/"}>
      <ChatIcon /> инфо
    </Item>,
    <Item to={"/protocol"}>
      <DockIcon /> протоколы
    </Item>,
    <Item to={"/albom"}>
      {" "}
      <PhotoCameraIcon /> фото соревнований
    </Item>,
    <Item to={"/zayavka"}>
      <SendIcon /> отправить заявку на соревнование
    </Item>,
    <Item to={"/calendar"}>
      {" "}
      <CalendarMonthIcon /> календарь
    </Item>,
    <Item to={"/documents"}>
      <DockIcon /> документы
    </Item>,
    <Item to={"/polog"}>
      <DockIcon /> положения
    </Item>,
    <Item to={"/norm"}>
      {" "}
      <FitnessCenterIcon /> нормативы
    </Item>,
    <Item to={"/sportsmens"}>
      <PeopleIcon /> наши спортсмены
    </Item>,
    <Item to={"/record"}>
      <FitnessCenterIcon /> рекорды рязанской области
    </Item>,
    <Item to={"/anti"}>
      <ReportProblemIcon /> антидопинг
    </Item>,
    <Item to={"/contacts"}>
      <ContactsIcon /> контакты
    </Item>,
    <Item to={"/lk"}>
      <AccountCircleIcon /> личный кабинет
    </Item>,
    staff ? (
      <Item to={"/admin"}>
        <AccountCircleIcon />
        _admin панель_
      </Item>
    ) : (
      <></>
    ),
  ];
  const settings = ["Profile", "Account", "Dashboard", "Logout"];

  // const showAdmin = (staff) => {
  //   if (staff && !pages.includes(el())) {
  //     // console.log("&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&");
  //     // console.log(pages.includes(el()));
  //     // console.log(pages);
  //     pages.push(el());
  //   } else {
  //     pages.pop(el());
  //   }
  // };

  const handleOpenNavMenu = (event) => {
    setAnchorElNav(event.currentTarget);
  };
  const handleOpenDocMenu = (event) => {
    setAnchorElDoc(event.currentTarget);
  };

  const handleOpenSportMenu = (event) => {
    setAnchorElSport(event.currentTarget);
  };

  const handleCloseNavMenu = () => {
    setAnchorElNav(null);
  };

  const handleCloseDocMenu = () => {
    setAnchorElDoc(null);
  };
  const handleCloseSportMenu = () => {
    setAnchorElSport(null);
  };

  // const getNewsFunc = (searchValue) => {
  //   api.getNews(searchValue).then((response) => {
  //     setData(response.data.news);
  //   });
  // };
  const token = useSelector((state) => state.userSelector.token);
  const getStaffUser = () => {
    api.getDateUser(token).then((response) => {
      if (response.data.sportsmen) {
        setStaff(response.data.sportsmen[0].status);
        // console.log(token);
        console.log(response.data);
      }
    });
  };

  useEffect(() => {
    // showAdmin(staff);
    getStaffUser(token);
    dispatch(setSearch(searchValue));
    // staff
    //   ? pages.push(<Item to={API_MEDIA + "/admin/"}>admin панель</Item>)
    //   : {};
  }, [token, searchValue]);
  return (
    <>
      <Bar>
        <Container maxWidth="xl" disableGutters>
          <Toolbar disableGutters>
            <Label />
            <Typography
              variant="h6"
              noWrap
              component="a"
              href="#app-bar-with-responsive-menu"
              sx={{
                mr: 2,
                display: { xs: "none", md: "flex" },
                fontFamily: "monospace",
                fontWeight: 700,
                letterSpacing: ".3rem",
                color: alpha(theme.color.secondary, 1),
                textDecoration: "none",
              }}
            >
              ФПР
            </Typography>

            <Box
              sx={{
                flexGrow: 1,
                display: { xs: "flex", lg: "none" },
              }}
            >
              <IconButton
                size="large"
                aria-label="account of current user"
                aria-controls="menu-appbar"
                aria-haspopup="true"
                onClick={handleOpenNavMenu}
                sx={{
                  color: (theme) => theme.color.secondary,
                }}
              >
                <MenuIcon />
              </IconButton>
              <Menu
                id="menu-appbar"
                anchorEl={anchorElNav}
                anchorOrigin={{
                  vertical: "bottom",
                  horizontal: "left",
                }}
                keepMounted
                transformOrigin={{
                  vertical: "top",
                  horizontal: "left",
                }}
                open={Boolean(anchorElNav)}
                onClose={handleCloseNavMenu}
                sx={{ display: { xs: "block", lg: "none" } }}
              >
                {pages.map((page) => (
                  <MenuItem key={page} onClick={handleCloseNavMenu}>
                    <Typography sx={{ textAlign: "center" }}>{page}</Typography>
                  </MenuItem>
                ))}
              </Menu>
            </Box>
            <Box
              sx={{
                display: { xs: "none", lg: "flex" },
              }}
            >
              <Item_Button href="/">инфо</Item_Button>
            </Box>

            <Box sx={{ display: { xs: "none", lg: "flex" } }}>
              <Tooltip title="Вложеное меню">
                <Item_Button onClick={handleOpenDocMenu}>документы</Item_Button>
              </Tooltip>
              <Menu
                slotProps={{
                  paper: {
                    style: {
                      backgroundColor: alpha(theme.color.main, 1), // Ваш цвет
                    },
                  },
                }}
                sx={{ mt: "45px" }}
                id="menu-appbar"
                anchorEl={anchorElDoc}
                anchorOrigin={{
                  vertical: "top",
                  horizontal: "right",
                }}
                keepMounted
                transformOrigin={{
                  vertical: "top",
                  horizontal: "right",
                }}
                open={Boolean(anchorElDoc)}
                onClose={handleCloseDocMenu}
              >
                <MenuItem key="docs" onClick={handleCloseDocMenu}>
                  <Item to={"/documents"}>документы</Item>
                </MenuItem>

                <MenuItem key="polo" onClick={handleCloseDocMenu}>
                  <Item to={"/polog"}>положения</Item>
                </MenuItem>

                <MenuItem key="norm" onClick={handleCloseDocMenu}>
                  <Item to={"/norm"}>нормативы</Item>
                </MenuItem>

                <MenuItem key="protocol" onClick={handleCloseDocMenu}>
                  <Item to={"/protocol"}>протоколы</Item>
                </MenuItem>

                <MenuItem key="norm" onClick={handleCloseDocMenu}>
                  <Item to={"/calendar"}>календарь</Item>
                </MenuItem>
              </Menu>
            </Box>

            <Box
              sx={{
                display: { xs: "none", lg: "flex" },
              }}
            >
              <Item_Button href="/albom">фото</Item_Button>
            </Box>

            <Box sx={{ display: { xs: "none", lg: "flex" } }}>
              <Tooltip title="Вложеное меню">
                <Item_Button onClick={handleOpenSportMenu}>
                  спортсмены
                </Item_Button>
              </Tooltip>
              <Menu
                slotProps={{
                  paper: {
                    style: {
                      backgroundColor: alpha(theme.color.main, 1), // Ваш цвет
                    },
                  },
                }}
                sx={{ mt: "45px" }}
                id="menu-appbar"
                anchorEl={anchorElSport}
                anchorOrigin={{
                  vertical: "top",
                  horizontal: "right",
                }}
                keepMounted
                transformOrigin={{
                  vertical: "top",
                  horizontal: "right",
                }}
                open={Boolean(anchorElSport)}
                onClose={handleCloseSportMenu}
              >
                <MenuItem key="sport1" onClick={handleCloseSportMenu}>
                  <Item to={"/record"}>рекорды</Item>
                </MenuItem>

                <MenuItem key="sport2" onClick={handleCloseSportMenu}>
                  <Item to={"/sportsmens"}>наши спортсмены</Item>
                </MenuItem>
                <MenuItem key="sport3" onClick={handleCloseSportMenu}>
                  <Item to={"/lk"}>личный кабинет</Item>
                </MenuItem>
                <MenuItem key="sport3" onClick={handleCloseSportMenu}>
                  <Item to={"/zayavka"}>отправить заявку на соревнование</Item>
                </MenuItem>

                {staff ? (
                  <MenuItem key="sport3" onClick={handleCloseSportMenu}>
                    <Item to={"/admin"}>admin панель</Item>
                  </MenuItem>
                ) : (
                  <></>
                )}
              </Menu>
            </Box>

            <Box
              sx={{
                display: { xs: "none", lg: "flex" },
              }}
            >
              <Item_Button href="/anti">антидопинг</Item_Button>
            </Box>

            <Box
              sx={{
                flexGrow: 1,
                display: { xs: "none", lg: "flex" },
              }}
            >
              <Item_Button href="/contacts">контакты</Item_Button>
            </Box>
            <Search>
              <SearchIconWrapper>
                <SearchIcon />
              </SearchIconWrapper>
              <StyledInputBase
                placeholder="Search…"
                inputProps={{ "aria-label": "search" }}
                value={searchValue}
                onChange={(e) => {
                  setSearchValue(e.target.value);
                }}
              />
            </Search>
            <Box>
              {/* <Switch
                onChange={() => dispatch(setTheme())}
                label="ТЕМА"
                // color={theme.color.secondary}
                color="warning"
              /> */}
              {/* <FormControlLabel
                onChange={() => dispatch(setTheme())}
                control={<MaterialUISwitch sx={{ m: 1 }} />}
                // label="Тема"
                // sx={{
                //   "& .MuiFormControlLabel-label": {
                //     color: theme.color.secondary, // Меняем цвет текста
                //   },
                // }}
              /> */}
              <MaterialUISwitch
                sx={{ m: 1 }}
                checked={!flag}
                onChange={() => dispatch(setTheme())}
              />
              {/* <Switch
                checked={flag}
                onChange={() => dispatch(setTheme())}
                name="toggle"
              /> */}
            </Box>
            {/* <box>{localStorage.getItem("theme")}</box> */}
          </Toolbar>
        </Container>
      </Bar>
    </>
  );
}
export default ResponsiveAppBar;
